import { useDispatch, useSelector } from 'react-redux';

import type { VendorAppDispatch, VendorAppRootState } from '../store';

export const useVendorAppDispatch = useDispatch.withTypes<VendorAppDispatch>();
export const useVendorAppSelector = useSelector.withTypes<VendorAppRootState>();
